<template>
  <div>
    <loginHeader />

    <div class="login">
      <div class="w1300">
        <div class="wrapper">
          <div class="title txt-c tit-32 fw700">登录</div>

          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            class="tabs"
            ref="parentRef"
          >
            <el-tab-pane label="短信登录" name="first" class="firstTab">
              <div class="item">
                <el-input
                  placeholder="请输入手机号"
                  v-model="userInfo.phone"
                  @blur="validatePhone"
                  :class="{ 'is-error': errors.phone }"
                ></el-input>
                <div class="erro" v-if="errors.phone">
                  <span class="tit-12">{{ errors.phone }}</span>
                </div>
              </div>

              <div class="item">
                <drag-verify
                  v-model="userInfo.verify"
                  ref="dragVerify"
                  :width="dragWidth"
                  :height="dragHeight"
                  :isPassing.sync="isPassing"
                  text="请按住滑块拖动"
                  successText="验证通过"
                  handlerIcon="el-icon-d-arrow-right"
                  successIcon="el-icon-circle-check"
                  @passcallback="passcallback"
                >
                  <i
                    v-show="!isPassing"
                    slot="textBefore"
                    class="el-icon-lock"
                  ></i>
                </drag-verify>

                <div class="erro" v-if="errors.verify">
                  <span class="tit-12">{{ errors.verify }}</span>
                </div>
              </div>

              <div class="item getCode">
                <el-input
                  placeholder="请输入验证码"
                  class="mr-10"
                  v-model="userInfo.code"
                  maxlength="6"
                  @blur="validateCode"
                  :class="{ 'is-error': errors.code }"
                ></el-input>
                <el-button
                  @click="sendCode"
                  :disabled="!canSend || countdown > 0"
                >
                  {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
                </el-button>

                <div class="erro" v-if="errors.code">
                  <span class="tit-12">{{ errors.code }}</span>
                </div>
              </div>

              <div class="item sub">
                <el-button
                  type="primary"
                  class="btn"
                  @click="submitForm"
                  :loading="loading"
                >
                  登录
                </el-button>
              </div>

              <div class="item tit-14 txt-c">
                <span>新用户？</span>
                <router-link to="/register" class="forget cor-0030F5">
                  注册优理奇账号
                </router-link>
              </div>
            </el-tab-pane>
            <el-tab-pane label="密码登录" name="second" class="secondTab">
              <div class="item">
                <el-input
                  placeholder="请输入手机号"
                  v-model="userInfo.phone"
                  @blur="validatePhone"
                  :class="{ 'is-error': errors.phone }"
                ></el-input>
                <div class="erro" v-if="errors.phone">
                  <span class="tit-12">{{ errors.phone }}</span>
                </div>
              </div>

              <div class="item">
                <el-input
                  placeholder="请输入密码"
                  type="password"
                  v-model="password"
                  @blur="validatePassword"
                  show-password
                  :class="{ 'is-error': errors.password }"
                ></el-input>
                <div class="erro" v-if="errors.password">
                  <span class="tit-12">{{ errors.password }}</span>
                </div>
              </div>

              <div class="item forgetPass tit-14">
                <router-link to="/forgetPwd" class="cor-0030F5">
                  忘记密码
                </router-link>
              </div>

              <div class="item sub">
                <el-button
                  type="primary"
                  class="btn"
                  @click="passwordSubmit"
                  :loading="loading"
                >
                  登录
                </el-button>
              </div>

              <div class="item tit-14 txt-c">
                <span>新用户？</span>
                <router-link to="/register" class="forget cor-0030F5">
                  注册优理奇账号
                </router-link>
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="copyRight txt-c tit-14">
            <div>
              <span @click="showDialog(1)" class="cur">用户协议 · </span>
              <span @click="showDialog(2)" class="cur">
                隐私政策
              </span>
              <!-- <span>苏ICP备1234567890号 </span> -->
            </div>
            <div>{{ shu.synopsis.hezuopeizhi.beianhao }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="50%"
      top="0"
      :before-close="handleClose"
    >
      <div class="info">
        <!-- 协议内容展示区域 -->
        <div class="info tit-333" v-html="dialogContent.neirong"></div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
let that;
import loginHeader from "@/components/loginHeader.vue";
// import { getCode, login } from "@/api/login";

import dragVerify from "vue-drag-verify2";
import { h } from "vue";

export default {
  name: "LoginIndex",

  components: {
    loginHeader,
    dragVerify,
  },

  data() {
    return {
      activeName: "first",
      dragWidth: 465, // 默认宽度（PC端）
      dragHeight: 50, // 默认高度
      isPassing: false,
      loading: false,
      canSend: true, // 是否可以发送验证码
      countdown: 0, // 倒计时
      timer: null, // 定时器
      userInfo: {
        phone: "",
        verify: "",
        code: "",
      },
      password: "",

      errors: {
        phone: "",
        verify: "",
        code: "",
        password: "",
      },
      shu: { synopsis: { hezuopeizhi: {} } },

      // 弹窗
      dialogVisible: false,
      // 弹窗标题
      dialogTitle: "",
      // 弹窗内容
      dialogContent: "", // 用于存储当前要显示的内容类型
    };
  },

  created() {
    that = this;
    that.$post("k=company", function(s) {
      that.shu = s.shu;
    });
  },
  watch: {
    "userInfo.phone": function() {
      this.checkCanSend();
    },
    isPassing: function() {
      this.checkCanSend();
    },
  },

  methods: {
    handleClick(tab, event) {
      // 切换标签页时重置表单
      this.isPassing = false;
      this.resetForm();
      if (this.$refs.dragVerify) {
        this.$refs.dragVerify.reset();
      }
    },

    // 验证手机号
    validatePhone() {
      if (!this.userInfo.phone) {
        this.errors.phone = "请输入手机号码";
        return false;
      }
      if (!/^1[3-9]\d{9}$/.test(this.userInfo.phone)) {
        this.errors.phone = "请输入正确的手机号码";
        return false;
      }
      this.errors.phone = "";
      return true;
    },

    // 验证验证码
    validateCode() {
      if (!this.userInfo.code) {
        this.errors.code = "请输入验证码";
        return false;
      }
      if (!/^\d{6}$/.test(this.userInfo.code)) {
        this.errors.code = "验证码为6位数字";
        return false;
      }
      this.errors.code = "";
      return true;
    },

    // 检查是否可以发送验证码
    checkCanSend() {
      this.canSend = this.validatePhone() && this.isPassing;
    },

    // 滑块验证通过回调
    passcallback() {
      this.errors.verify = "";
      this.checkCanSend(); // 添加这行
    },

    // 发送验证码
    sendCode() {
      if (!this.validatePhone()) return;
      if (!this.isPassing) {
        this.errors.verify = "请完成滑块验证";
        return;
      }

      // 模拟发送验证码
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
      this.$post(
        "k=denglu&x=zhuce",
        { c: "yanzhengma", shouji: this.userInfo.phone },
        (s) => {
          this.$xiaoxi(s.shu);
          if (s.shi == 1) {
            this.$message.success("验证码已发送 " + res.message);
          } else {
            clearInterval(stop);
          }
        },
      );
    },

    // 提交表单
    submitForm() {
      if (!this.validatePhone()) return;
      if (!this.isPassing) {
        this.errors.verify = "请完成滑块验证";
        return;
      }
      if (!this.validateCode()) return;

      this.loading = true;

      // 模拟登录请求
      setTimeout(() => {
        this.loading = false;

        that.$post(
          "k=denglu&c=Shoujidenglu",
          { zhanghao: that.userInfo.phone, yanzheng: that.userInfo.code },
          function(s) {
            if (s.shi == 1) {
              that.$quanju("$yonghux", s.shu);
              that.$cun("yonghux", s.shu);
              that.$store.commit("gaiyonghux", s.shu);
              that.$dakai("/");
            } else {
              that.$message.error(s.shu);
            }
          },
        );
        // login({
        //   form: {
        //     isParty: false,
        //     partyData: {},
        //     mobile: this.userInfo.phone,
        //     smsCode: this.userInfo.code,
        //   },
        // }).then((res) => {
        //   this.$store.commit("user/setUserInfo", res.data);

        //   // console.log(res);
        //   this.$message.success("登录成功");
        //   // 登录成功后跳转到首页或其他页面;
        //   this.$router.push("/");
        // });
      }, 1000);
    },

    // 重置表单
    resetForm() {
      this.userInfo = {
        phone: "",
        verify: "",
        code: "",
      };
      this.errors = {
        phone: "",
        verify: "",
        code: "",
        password: "",
      };
      this.isPassing = false;
      clearInterval(this.timer);
      this.countdown = 0;
    },

    validatePassword() {
      if (!this.password) {
        this.errors.password = "请输入密码";
        return false;
      }
      this.errors.password = "";
      return true;
    },

    passwordSubmit() {
      console.log(8888);
      if (!this.validatePhone()) return;
      if (!this.validatePassword()) return;
      that.$post(
        "k=denglu",
        { zhanghao: that.userInfo.phone, mima: that.password },
        function(s) {
          if (s.shi == 1) {
            that.$quanju("$yonghux", s.shu);
            that.$cun("yonghux", s.shu);
            that.$store.commit("gaiyonghu", s.shu);
            that.$dakai("/");
          } else {
            that.$message.error(s.shu);
          }
        },
      );
      // this.loading = true;
      // login({
      //   form: {
      //     isParty: false,
      //     partyData: {},
      //     mobile: this.userInfo.phone,
      //     password: this.password,
      //   },
      // }).then((res) => {
      //   this.$store.commit("user/setUserInfo", res.data);
      //   // console.log(res);
      //   this.$message.success("登录成功");
      //   // 登录成功后跳转到首页或其他页面;
      //   this.$router.push("/");
      // });
    },

    // 显示弹窗
    showDialog(type) {
      let apiParam = "";

      console.log(1);

      // 根据类型设置标题和接口参数
      if (type === 1) {
        this.dialogTitle = "用户协议";
        apiParam = "用户协议";
      } else if (type === 2) {
        this.dialogTitle = "隐私政策";
        apiParam = "隐私政策";
      }

      // 有接口参数时发起请求
      if (apiParam) {
        // 发起POST请求获取协议内容
        this.$post(
          "k=wenzhang&c=xiangqing",
          {
            id: apiParam,
            // ye: 1, // 页码（固定第一页）
            // jitiao: 20, // 条数（足够获取所有协议）
          },
          (response) => {
            // 请求成功且有有效内容
            if (response.shi === 1) {
              console.log(response);

              this.dialogContent = response.shu;
            } else {
              // 请求失败时显示提示文本
              this.dialogContent =
                type === 1
                  ? "获取用户服务协议内容失败"
                  : "获取隐私政策内容失败";
            }
          },
          (error) => {
            // 网络请求失败的容错处理
            console.error("协议内容请求失败：", error);
            this.dialogContent = "网络异常，获取协议内容失败，请稍后重试";
          },
        );
      }

      // 显示弹窗
      this.dialogVisible = true;
    },

    handleClose(done) {
      // 关闭对话框的处理逻辑
      done();
    },

    adjustDragSize() {
      // 获取屏幕宽度，判断是否为移动端
      const screenWidth = window.innerWidth;

      // 获取父元素的实际宽度（含padding/border，按需调整）
      const parentEl = this.$refs.parentRef;
      if (!parentEl) return;

      // console.log(parentEl.$el.clientWidth, "parentEl");

      if (screenWidth < 768) {
        // 父元素宽度（clientWidth：不含margin，含padding/border）
        this.dragWidth = parentEl.$el.clientWidth;
        this.dragHeight = 45; // 移动端高度（也可设为 screenWidth * 0.08 等比例值）
      } else {
        // PC端：恢复原固定值
        this.dragWidth = 465;
        this.dragHeight = 50;
      }
    },
  },

  mounted() {
    // 2. 监听屏幕尺寸变化，动态调整宽高
    this.adjustDragSize();
    window.addEventListener("resize", this.adjustDragSize);
  },

  // 组件销毁前清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.login .w1300 {
  min-height: calc(100vh - 70px);
  padding: 5vh 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .wrapper {
    width: 100%;
  }
}

.tabs {
  width: 465px;
  min-width: 300px;
  margin: 0 auto;
  margin-top: 40px;

  /deep/.el-tabs__nav {
    width: 100%;

    .el-tabs__active-bar {
      background: #333333;
    }

    .el-tabs__item {
      width: 50%;
      text-align: center;
      height: 45px;
      line-height: initial;
      color: #b4b4b4;
      letter-spacing: 1px;
      font-size: var(--font16);

      &.is-active {
        color: #333333;
        font-weight: 700;
      }
    }
  }

  // 短信登录

  .firstTab {
    .item {
      margin: 25px 0;
      position: relative;
      .label {
        margin-bottom: 0.1rem;
      }

      /deep/ .el-input__inner {
        background: #ededed;
        border-radius: 100px;
        height: 52px;
        padding: 0 35px;

        &::placeholder {
          color: #9a9a9a;
        }
      }
    }

    /deep/ .getCode {
      .el-input__inner {
        padding-right: 120px;
      }
      button {
        position: absolute;
        right: 0;
        height: 100%;
        top: 0;
        background: none;
        border: 0;
      }
    }

    .sub {
      width: 100%;
      /deep/ button {
        border: 0;
        padding: 18px 0;
        width: 100%;
        background: #000000;
        border-radius: 100px;
        font-size: var(--font16);
      }
    }
  }

  // 账号登录
  .secondTab {
    .item {
      margin: 25px 0;
      position: relative;
      .label {
        margin-bottom: 0.1rem;
      }

      /deep/ .el-input__inner {
        background: #ededed;
        border-radius: 100px;
        height: 52px;
        padding: 0 35px;

        &::placeholder {
          color: #9a9a9a;
        }
      }
    }

    .forgetPass {
      padding-left: 35px;

      a {
        text-decoration-line: underline;
      }
    }

    .sub {
      width: 100%;
      /deep/ button {
        border: 0;
        padding: 18px 0;
        width: 100%;
        background: #000000;
        border-radius: 100px;
        font-size: var(--font16);
      }
    }
  }

  // 滑块验证
  /deep/ .drag_verify {
    border-radius: 100px !important;
    .dv_handler {
      border: 1px solid #ccc;
      border-radius: 50%;
    }
  }

  .erro {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 35px;
  }

  .is-error {
    /deep/ .el-input__inner {
      border-color: #f56c6c;
    }
  }
}

// 弹窗
/deep/ .el-dialog {
  top: 5vh;
  margin: 5vh auto;
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
    .info {
      color: initial;

      h2 {
        margin: revert;
      }
      ol {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: inherit;
        }
      }

      ul {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: initial;
        }
      }
    }
  }
  .el-dialog__footer {
    text-align: center;

    .el-button--primary {
      border: 0;
      background: #000000;
    }
  }
}

@media screen and (max-width: 767px) {
  .tabs {
    width: 100%;

    /deep/ .el-tabs__nav .el-tabs__item {
      height: 36px;
    }

    /deep/ .firstTab .item {
      margin: 18px 0;

      .el-input__inner {
        height: 45px;
      }
    }

    /deep/ .secondTab .item {
      margin: 18px 0;

      .el-input__inner {
        height: 45px;
      }
    }
  }

  /deep/ .el-dialog {
    width: 90% !important;
  }
}
</style>
